import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/contact_hero.png")